import { Escala } from '@core/models/models';

export type EstadoEscalaVisual = 'agendada' | 'decorrendo' | 'concluida' | 'outro';

export function obterEstadoEscalaVisual(escala: Pick<Escala, 'estado' | 'estadoDescricao'> | null | undefined): EstadoEscalaVisual {
  const estado = escala?.estado;
  const estadoNumerico =
    typeof estado === 'number'
      ? estado
      : typeof estado === 'string' && /^\d+$/.test(estado.trim())
        ? Number(estado.trim())
        : null;

  if (estadoNumerico !== null) {
    if (estadoNumerico === 0) return 'agendada';
    if (estadoNumerico === 1) return 'decorrendo';
    if (estadoNumerico === 2) return 'concluida';
    return 'outro';
  }

  const descricao = String(escala?.estadoDescricao ?? estado ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  if (descricao.includes('agend')) return 'agendada';
  if (descricao.includes('decorr') || descricao.includes('exec')) return 'decorrendo';
  if (descricao.includes('conclu')) return 'concluida';
  return 'outro';
}
